import { useTranslation } from 'react-i18next';

import {
	ContactsSelectWithSearch,
	ContactsSelectWithSearchProps,
	Modal,
	ModalProps,
} from '@pletly/ui';

export type Props = Omit<ModalProps, 'title'> & Pick<ContactsSelectWithSearchProps, 'contacts'>;

export const MembersAcceptedModal = ({ contacts, ...modalProps }: Props) => {
	const { t } = useTranslation();

	return (
		<Modal title={t('terms-of-use.members-who-accepted')} {...modalProps}>
			<ContactsSelectWithSearch
				mode="multi"
				contacts={contacts}
				selectedIds={contacts.map((contact) => contact.id)}
				setSelectedIds={() => undefined}
			/>
		</Modal>
	);
};
